import { gameSystems } from "@/data/globals";
import { GameEngines, GameSystems, IGameSystem } from "@/data/types";

export class GameSystemService {
  public static parse(value: string | number): GameSystems | null {
    if (typeof value === "undefined") return null;
    if (typeof value === "number") return value as GameSystems;
    if (typeof value === "string") {
      const intValue = parseInt(value);
      if (isNaN(intValue)) {
        return GameSystems[value];
      } else {
        return intValue as GameSystems;
      }
    }
  }
  public static findAll(): IGameSystem[] {
    return Object.values(gameSystems);
  }

  public static findByEngine(engineId: GameEngines): IGameSystem[] {
    return Object.values(gameSystems).filter((x) => x.engineId === engineId);
  }

  public static findById(id: number | string): IGameSystem {
    if (!id) return null;
    const gsValues = Object.values(gameSystems);
    if (typeof id === "number") {
      return gsValues.find((x) => x.id === id);
    } else {
      return (
        gsValues.find((x) => x.id === parseInt(id)) ??
        gsValues.find((x) => x.key.toLowerCase() === (id as string)?.toLowerCase())
      );
    }
  }

  public static findBySlug(slug: string): IGameSystem {
    return Object.values(gameSystems).find((x) => x.slug === slug);
  }

  public static isBattle(gs: { id: number }): boolean {
    return gs?.id === GameSystems.gf || gs?.id === GameSystems.aof || gs?.id === GameSystems.aofr;
  }

  public static isSkirmish(gs: { id: number }): boolean {
    return gs?.id === GameSystems.gff || gs?.id === GameSystems.aofs;
  }

  public static isQuest(gs: { id: number }): boolean {
    return (
      gs?.id === GameSystems.aofq ||
      gs?.id === GameSystems.aofqai ||
      gs?.id === GameSystems.gfsq ||
      gs?.id === GameSystems.gfsqai
    );
  }

  public static isQuestAI(gs: { id: number }): boolean {
    return gs?.id === GameSystems.aofqai || gs?.id === GameSystems.gfsqai;
  }

  public static isGrimdark(gs: { id: number }): boolean {
    return (
      gs?.id === GameSystems.gf ||
      gs?.id === GameSystems.gff ||
      gs.id === GameSystems.gfsq ||
      gs.id === GameSystems.gfsqai
    );
  }

  public static isFantasy(gs: { id: number }): boolean {
    return (
      gs?.id === GameSystems.aof ||
      gs?.id === GameSystems.aofs ||
      gs?.id === GameSystems.aofr ||
      gs?.id === GameSystems.aofq ||
      gs?.id === GameSystems.aofqai
    );
  }

  public static toSlug(gs: GameSystems) {
    return Object.values(gameSystems).find((x) => x.id === gs)?.slug;
  }

  public static toDisplayName(gs: GameSystems) {
    return Object.values(gameSystems).find((x) => x.id === gs)?.name;
  }

  public static getQuestAI(gs: GameSystems) {
    if (gs === GameSystems.aofq) return GameSystems.aofqai;
    if (gs === GameSystems.gfsq) return GameSystems.gfsqai;
    return null;
  }
}
